import { t } from '@/components/OldTable/locale';

export default {
  methods: {
    t(...args) {
      return t.apply(this, args);
    }
  }
};
